module.exports = __webpack_public_path__ + "img/bank-088.506f8b9c.png";